import React, { useMemo } from 'react';
import type { SuperButtonProps } from './super-button.types';
import Button from '../../atoms/button';
import { cn } from '../../utils/cn';
import { Checkbox } from '../../atoms/checkbox';
import { Text } from '../../atoms/text';
import { DiscountBox } from '../discount-box';
import { DotsLoader } from '../dots-loader';

import styles from './super-button.module.css';
import { PriceBox } from '../price-box';

export const SuperButton: React.FC<SuperButtonProps> = ({
    containerClassName,
    primaryText,
    primarySubText,
    loading,
    checkBoxLabel,
    checkBoxLabelProps,
    checkBoxProps,
    primaryTextProps,
    primarySubTextProps,
    extra,
    buttonProps,
    disabled,
}) => {
    const superButtonStyles = useMemo(() => {
        return {
            container: cn(styles.container, containerClassName),
            checkBoxLabel: cn(styles.checkboxLabel, checkBoxLabelProps?.className),
            button: cn(styles.button, buttonProps?.className),
            primaryText: cn(styles.primaryText, primaryTextProps?.className),
            primarySubText: cn(styles.primarySubText, primarySubTextProps?.className),
        };
    }, [
        containerClassName,
        checkBoxLabelProps?.className,
        buttonProps?.className,
        primaryTextProps?.className,
        primarySubTextProps?.className,
    ]);

    if (loading) {
        return (
            <div className={superButtonStyles.container} data-testid="super-button-container">
                <div className={styles.loading} data-testid="super-button-loader">
                    <DotsLoader size="large" color="white" />
                </div>
            </div>
        );
    }

    return (
        <div className={superButtonStyles.container} data-testid="super-button-container">
            <div className={styles.content}>
                <div className={styles.leftContent}>
                    {checkBoxProps?.onCheckedChange && (
                        <div className={styles.checkbox} data-testid="super-button-checkbox">
                            <Checkbox size={'medium'} mode="reverse" {...checkBoxProps} />
                            <Text
                                showIf={!!checkBoxLabel}
                                className={superButtonStyles.checkBoxLabel}
                                {...checkBoxLabelProps}
                            >
                                {checkBoxLabel}
                            </Text>
                        </div>
                    )}

                    <PriceBox
                        finalPrice={primaryText}
                        originalPrice={primarySubText}
                        containerClassName={styles.primaryLabel}
                        finalPriceClassName={styles.primaryText}
                        originalPriceClassName={styles.primarySubText}
                    />
                </div>

                {extra && <DiscountBox primaryText="Tiết kiệm" {...extra} />}

                <Button
                    variant="contained"
                    data-testid="super-button-action"
                    disabled={disabled}
                    showIf={!!buttonProps}
                    {...buttonProps}
                    className={superButtonStyles.button}
                ></Button>
            </div>
        </div>
    );
};
